import * as React from "react";
import { useAsync } from "react-use";
import { useApi } from "./ApiContainer";
import { createContainer } from "./StateContainer";
import { withRetry } from "../utils/retry";

type Schema = {
  [key: string]: string[];
};

const useSchemaContainerState = (): {
  schema: Schema | undefined;
  loading: boolean;
} => {
  const { postgrest } = useApi();
  const { value, loading } = useAsync(async () => {
    return withRetry(
      async () => {
        const { data, error } = await postgrest.rpc("columns");

        if (error) {
          throw new Error(`Schema RPC error: ${error.message}`);
        }

        if (!data || !Array.isArray(data)) {
          throw new Error("Invalid schema data received");
        }

        return Object.fromEntries(
          data.map((row: { table_name: string; column_names: string[] }) => [
            row.table_name,
            row.column_names,
          ])
        );
      },
      {
        onRetry: (attempt, err) => {
          console.warn(`Schema fetch retry ${attempt}:`, err.message);
        },
      }
    );
  }, [postgrest]);
  return { schema: value, loading };
};
const SchemaContainerState = createContainer(useSchemaContainerState);

export const SchemaContainer: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <SchemaContainerState.Provider>{children}</SchemaContainerState.Provider>
  );
};

/**
 * Hook into the current identity context.
 */
export const useSchema = SchemaContainerState.useContainer;
